export default __webpack_public_path__ + "static/media/意外险.e4a32713.jpg";